import { ColourTokenRadio } from 'approot/shared/colour/colour-token';
import { SettingsGroup, SettingsLabel } from '../settings/settings.style';
import {
  BACKGROUND_COLOURS,
  COLOUR_OPTION,
  IMAGE_OPTION,
} from './styles-drawer.constants';
import { CheckableSingle } from 'approot/shared/styles/buttons/checkable-input';
import { Box } from 'approot/shared/design-system/box/box.style';
import { FileDropperContextProvider } from 'lib/form/file-dropper/file-dropper.context';
import { COLOUR_GREY } from 'approot/shared/colour/colour.constants';
import ImageUploadField, {
  ImageProps,
  ImageUploadFunction,
} from '../components/shared/image-upload-field';
import { StylesBackgroundColours } from './styles-background.style';

export const BackgroundOptionsFields = ({
  backgroundOption,
  onClickBackgroundOption,
}: {
  backgroundOption: typeof COLOUR_OPTION | typeof IMAGE_OPTION;
  onClickBackgroundOption: (
    value: typeof COLOUR_OPTION | typeof IMAGE_OPTION
  ) => void;
}) => {
  return (
    <SettingsGroup>
      <SettingsLabel>Background Options</SettingsLabel>
      <CheckableSingle
        variant="pill"
        name="background"
        selected={backgroundOption}
        options={[
          {
            label: 'Colours',
            value: COLOUR_OPTION,
            'aria-label': 'Set the background to a pre-defined colour',
            onClick: onClickBackgroundOption,
          },
          {
            label: 'Upload Image',
            value: IMAGE_OPTION,
            'aria-label': 'Set the background to an image you upload',
            onClick: onClickBackgroundOption,
          },
        ]}
      />
    </SettingsGroup>
  );
};

export const BackgroundColourFields = ({
  backgroundColour,
  onChangeColour,
}: {
  backgroundColour?: string;
  onChangeColour: (colour: string) => void;
}) => {
  return (
    <SettingsGroup>
      <SettingsLabel>Background Colour</SettingsLabel>
      <StylesBackgroundColours>
        {BACKGROUND_COLOURS.map(item => (
          <ColourTokenRadio
            key={item.colour1}
            name="colourField"
            colours={item}
            isActive={
              backgroundColour
                ? item.colour1 === backgroundColour ||
                  item.base === backgroundColour
                : item.colour1 === COLOUR_GREY.colour1
            }
            onChange={() => onChangeColour(item.base)}
          />
        ))}
      </StylesBackgroundColours>
    </SettingsGroup>
  );
};

export const BackgroundImageFields = ({
  image,
  onImageUpload,
  onImageDelete,
}: {
  image: ImageProps;
  onImageUpload: ImageUploadFunction;
  onImageDelete: () => void;
}) => {
  return (
    <SettingsGroup>
      <SettingsLabel>Background Image</SettingsLabel>
      <Box $marginBottom={24}>
        <FileDropperContextProvider>
          <ImageUploadField
            image={image}
            onImageUpload={onImageUpload}
            onDelete={onImageDelete}
          />
        </FileDropperContextProvider>
      </Box>
    </SettingsGroup>
  );
};
